import fp from 'lodash/fp';
import React, { FC } from 'react';

import { Stack } from '../../Stack';
import { Header } from './Header';
import { List } from './List';


const hoursRange = fp.range(0, 24);
const minutesRange = fp.range(0, 60);

type TimeData = {
    value: number | null;
    onChange: (value: number) => void;
};

export type TimePickerProps = {
    /** Хранение данных для часов */
    hours: TimeData;
    /** Хранение данных для минут */
    minutes: TimeData;
};

/** Компонент выбора времени. Хранение данных вынесено отдельно по каждому значению
 * @see [Незаполненный](https://www.figma.com/design/nyOI7hySHz5glWUuMIdVpZ/%F0%9F%A7%A9-%5BWeb%5D-Components-Factorin?node-id=4850-16243&m=dev)
 * @see [Заполненный](https://www.figma.com/design/nyOI7hySHz5glWUuMIdVpZ/%F0%9F%A7%A9-%5BWeb%5D-Components-Factorin?node-id=4850-16246&m=dev)
 */
export const TimePicker: FC<TimePickerProps> = ({ hours, minutes }) => (
    <Stack
        spacing={2}
        py={1.5}
        pl={3}
        pr={2}
        overflow='auto'
        fontFamily='Roboto'
        height='100%'
    >
        <Header>
            {`${hours.value ?? '--'}`.padStart(2, '0')}:
            {`${minutes.value ?? '--'}`.padStart(2, '0')}
        </Header>
        <Stack direction='row' spacing={1} height='100%' overflow='auto'>
            <List
                header='Час'
                options={hoursRange}
                selected={hours.value}
                onChange={hours.onChange}
                defaultScrollStartElement={hours.value ?? 13}
            />
            <List
                header='Мин.'
                options={minutesRange}
                selected={minutes.value}
                onChange={minutes.onChange}
                defaultScrollStartElement={minutes.value}
            />
        </Stack>
    </Stack>
);
